export enum Category {
  foodAndDrink = 'food-and-drink',
  fadVegan = 'food-and-drink-vegan',
  fadFamilyFriendly = 'food-and-drink-family-friendly',
  fadGlutenFree = 'food-and-drink-gluten-free',
  fadDessertsAndBaking = 'food-and-drink-desserts-and-baking',
  fadBarbecuesAndGrilling = 'food-and-drink-barbecues-and-grilling',
  fadCocktailsSlashBeer = 'food-and-drink-cocktails-slash-beer',
  fadWine = 'food-and-drink-wine',
  fadVegetarian = 'food-and-drink-vegetarian',
  fadPaleo = 'food-and-drink-paleo',
  fadHealthyCooking = 'food-and-drink-healthy-cooking',
  fadFoodAllergies = 'food-and-drink-food-allergies',
  fadLowCarb = 'food-and-drink-low-carb',
  fadWholeFoods = 'food-and-drink-whole-foods',
  fadWalletFriendly = 'food-and-drink-wallet-friendly',
  artsAndEntertainment = 'arts-and-entertainment',
  aneTelevision = 'arts-and-entertainment-television',
  aneCelebrityFanSlashGossip = 'arts-and-entertainment-fan-slash-gossip',
  aneMovies = 'arts-and-entertainment-movies',
  education = 'education',
  styleAndFashion = 'style-and-fashion',
  healthAndFitness = 'health-and-fitness',
  hobbiesAndInterests = 'hobbies-and-interests',
  haiArtsAndCrafts = 'hobbies-and-interests-arts-and-crafts',
  haiSewing = 'hobbies-and-interests-sewing',
  homeAndGarden = 'home-and-garden',
  hagInteriorDecorating = 'home-and-garden-interior-decorating',
  hagLandscaping = 'home-and-garden-landscaping',
  hagGardening = 'home-and-garden-gardening',
  hagEntertaining = 'home-and-garden-entertaining',
  hagRemodelingAndConstruction = 'home-and-garden-remodeling-and-construction',
  travel = 'travel',
  personalFinance = 'personal-finance',
  pfCouponing = 'personal-finance-couponing',
  familyAndParenting = 'family-and-parenting'
}
